import { Box, styled, StyleSystemProps } from '@withjoy/joykit';

export const StyledBoxDivider = styled(Box)``;

const boxDividerStyles: StyleSystemProps = {
  paddingY: 5,
  borderBottomStyle: 'solid',
  borderBottomColor: 'mono3',
  borderBottomWidth: '1px',
  borderTopStyle: 'solid',
  borderTopColor: 'mono3',
  borderTopWidth: '1px',
  marginBottom: 6,
};

export const styles = {
  boxDividerStyles,
};
